// extracted by mini-css-extract-plugin
export default {"moduleItemWrapper":"ModuleModal_moduleItemWrapper__RLzWU","modalItemLesson":"ModuleModal_modalItemLesson__YIGbR"};